import { render, staticRenderFns } from "./GeneroCard.vue?vue&type=template&id=6160595c&scoped=true"
import script from "./GeneroCard.vue?vue&type=script&lang=js"
export * from "./GeneroCard.vue?vue&type=script&lang=js"
import style0 from "./GeneroCard.vue?vue&type=style&index=0&id=6160595c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160595c",
  null
  
)

export default component.exports